import { useCampaignPerformanceEnabled } from '@/features/campaignPerformance';
import RouteConstants from '@/features/router/RouteConstants';
import { FC } from 'react';
import { SidebarBase } from '../common';
import { SIDEBAR_CONFIG } from '../common/constants';

type SidebarNavigationProps = {
  className?: string;
};

export const SidebarNavigation: FC<SidebarNavigationProps> = ({ className }) => {
  const campaignPerformanceEnabled = useCampaignPerformanceEnabled();
  const items = SIDEBAR_CONFIG.filter((item) => item.path !== RouteConstants.campaignPerformance || campaignPerformanceEnabled);

  return (
    <SidebarBase.Navigation className={className}>
      <div className='grow'>
        {items.map((item) => (
          <SidebarBase.NavItem
            key={item.path}
            {...item}
            classNames={{
              text: 'text-secondary-700',
            }}
          />
        ))}
      </div>
    </SidebarBase.Navigation>
  );
};
